import * as React from "react";
const SvgEllipsis = (props) => /* @__PURE__ */ React.createElement("svg", props, /* @__PURE__ */ React.createElement("path", { d: "M20 16.16a3.841 3.841 0 0 1 0 7.68 3.841 3.841 0 0 1 0-7.68Zm-3.84-8.32a3.841 3.841 0 0 0 7.68 0 3.841 3.841 0 0 0-7.68 0Zm0 24.32a3.841 3.841 0 0 0 7.68 0 3.841 3.841 0 0 0-7.68 0Z" }));
export default SvgEllipsis;
